<div class="modal-header">
  <h5 class="modal-title">
    <i class="fab fa-airbnb"></i>
    Booking Alteration
    <app-page-help articleId="ap1ns89113"></app-page-help>
  </h5>
  <button (click)="dialogRef.close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <table class="table table-striped">
    <tr>
      <th></th>
      <th>Before</th>
      <th>After</th>
    </tr>
    <tr>
      <td>Listing</td>
      <td>
        <app-rental-name [rentalId]="inquiry.rentalId"></app-rental-name>
      </td>
      <td>
        <app-rental-name [rentalId]="$safeNavigationMigration((targetRental$ | async)?.id)"></app-rental-name>
      </td>
    </tr>
    <tr>
      <td>Arrival Date</td>
      <td>{{ inquiry.guestArrive | epochUTC : 'YYYY-MM-DD' }}</td>
      <td>{{ alteration?.start_date }}</td>
    </tr>
    <tr>
      <td>Departure Date</td>
      <td>{{ inquiry.guestDepart | epochUTC : 'YYYY-MM-DD' }}</td>
      <td>{{ alteration?.end_date }}</td>
    </tr>
    <tr>
      <td>Adult</td>
      <td>{{ inquiry.numAdults }}</td>
      <td>{{ alteration?.guest_details.number_of_adults }}</td>
    </tr>
    <tr>
      <td>Children</td>
      <td>{{ inquiry.numChild }}</td>
      <td>{{ alteration?.guest_details.number_of_children }}</td>
    </tr>
    <tr>
      <td>Infants</td>
      <td>{{ inquiry?.num_infants || 0 }}</td>
      <td>{{ alteration?.guest_details.number_of_infants }}</td>
    </tr>
    <tr>
      <td>Pets</td>
      <td>{{ inquiry?.num_pets || 0 }}</td>
      <td>{{ alteration?.guest_details.number_of_pets }}</td>
    </tr>
    <ng-container *ngIf="sourceRental$ | async as sourceRental">
      <tr class="font-weight-bold">
        <td>Base Price</td>
        <td>{{ inquiry.abb_price?.base || 0 | tokeetCurrency : $safeNavigationMigration(sourceRental?.currency) }}</td>
        <td>
          {{
            alteration?.listing_base_price_accurate || 0
              | tokeetCurrency : $safeNavigationMigration(sourceRental?.currency)
          }}
        </td>
      </tr>
      <tr class="font-weight-bold">
        <td>Payout</td>
        <td>
          {{ inquiry.abb_price?.payout || 0 | tokeetCurrency : $safeNavigationMigration(sourceRental?.currency) }}
        </td>
        <td>
          {{
            alteration?.expected_payout_amount_accurate || 0
              | tokeetCurrency : $safeNavigationMigration(sourceRental?.currency)
          }}
        </td>
      </tr>
    </ng-container>
  </table>
</div>
<div class="modal-footer">
  <div *ngIf="alteration?.status">
    <span i18n class="text-bold"> Alteration Status: </span>
    <span class="badge badge-info">{{ alteration?.status }} </span>
  </div>
  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i>
    Close
  </button>
  <ng-container *ngIf="!alterationId">
    <button
      (click)="onInitialAlteration()"
      type="button"
      [disabled]="isLoading"
      class="btn btn-secondary-info create-btn"
    >
      <i class="fal fa-check"></i> Initiate
    </button>
  </ng-container>
  <ng-container *ngIf="isHostAlteration && isPending">
    <button
      (click)="onCancel()"
      type="button"
      matTooltip="Cancel the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-outline-danger create-btn"
    >
      <i class="fal fa-ban"></i> Cancel
    </button>
  </ng-container>
  <ng-container *ngIf="isGuestAlteration && isPending">
    <button
      (click)="onDecline()"
      type="button"
      matTooltip="Decline the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-secondary-danger create-btn"
    >
      <i class="fal fa-ban"></i> Decline
    </button>
    <button
      (click)="onAccept()"
      type="button"
      matTooltip="Accept the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-secondary-success create-btn"
    >
      <i class="fal fa-check"></i> Accept
    </button>
  </ng-container>
</div>
